export const joinSteps = ['약관동의', '대표자 본인인증', 'PC방 정보입력', '가입완료'];
